<template>
  <div class="dashboard-v3-container">
    <!-- Top Modern Hero Header -->
    <header class="header-banner">
      <div class="header-left">
        <div class="greeting-badge">
          <span class="pulse-dot"></span>
          <span>BẢNG ĐIỀU KHIỂN THỐNG KÊ 3.0</span>
        </div>
        <h1 class="header-title">Hệ Thống Quản Lý Giáo Dục Mầm Non</h1>
        <p class="header-subtitle">
          <i class="el-icon-date"></i> {{ formattedCurrentDate }} &nbsp;|&nbsp;
          <i class="el-icon-office-building"></i> {{ currentSchoolName }}
        </p>
      </div>
    </header>

    <!-- Sticky Navigation Cards Bar (Cố định, Bỏ bộ lọc, Thẻ điều hướng đẹp mắt) -->
    <nav class="sticky-nav-wrapper">
      <div class="nav-cards-grid">
        <button
          v-for="nav in navSections"
          :key="nav.id"
          type="button"
          :class="['nav-card-tab', { active: activeNav === nav.id }]"
          :style="{
            '--accent-color': nav.color,
            '--accent-bg': nav.bgColor
          }"
          @click="scrollToSection(nav.id)"
        >
          <div class="nav-card-icon">
            <i :class="nav.icon"></i>
          </div>
          <div class="nav-card-info">
            <span class="nav-card-title">{{ nav.name }}</span>
            <span class="nav-card-sub">{{ nav.subtitle }}</span>
          </div>
          <div class="nav-card-glow-bar"></div>
        </button>
      </div>
    </nav>

    <!-- SECTION 1: THỐNG KÊ ĐIỂM DANH & CHUYÊN CẦN HỌC SINH -->
    <section id="section-attendance" class="dashboard-section">
      <AttendanceStatisticsV3 ref="attendanceComp" :auto-load="false"/>
    </section>

    <!-- SECTION 1.2: THỐNG KÊ CHUYÊN CẦN & CHẤM CÔNG NHÂN SỰ -->
    <section id="section-emp-attendance" class="dashboard-section">
      <EmployeeAttendanceStatisticsV3 ref="empAttendanceComp" :auto-load="false"/>
    </section>

    <!-- SECTION 2: THỐNG KÊ TIN TỨC & BẢN TIN -->
    <section id="section-news" class="dashboard-section">
      <NewsStatisticsV3 ref="newsComp" :auto-load="false"/>
    </section>

    <!-- SECTION 3: THỐNG KÊ NHẬN XÉT & ĐÁNH GIÁ HỌC SINH -->
    <section id="section-evaluation" class="dashboard-section">
      <EvaluationStatisticsV3 ref="evaluationComp" :auto-load="false"/>
    </section>

    <!-- SECTION 4: THỐNG KÊ THỜI KHÓA BIỂU -->
    <section id="section-schedule" class="dashboard-section">
      <ScheduleStatisticsV3 ref="scheduleComp" :auto-load="false"/>
    </section>

    <!-- SECTION 5: THỐNG KÊ THỰC ĐƠN -->
    <section id="section-menu" class="dashboard-section">
      <MenuStatisticsV3 ref="menuComp" :auto-load="false"/>
    </section>

    <!-- SECTION 6: THỐNG KÊ HOẠT ĐỘNG ALBUM ẢNH -->
    <section id="section-album" class="dashboard-section">
      <AlbumStatisticsV3 ref="albumComp" :auto-load="false"/>
    </section>



    <!-- SECTION 7: THỐNG KÊ HỌC PHÍ & KHOẢN THU -->
    <section id="section-tuition" class="dashboard-section">
      <TuitionStatisticsV3 ref="tuitionComp" :auto-load="false" />
    </section>

    <!-- SECTION 8: THỐNG KÊ KPI NHÂN SỰ -->
    <section id="section-personnel-kpi" class="dashboard-section">
      <PersonnelKpiV3 ref="personnelKpiComp" :auto-load="false" />
    </section>

    <!-- SECTION 9: THỐNG KÊ SINH NHẬT -->
    <section id="section-birthday" class="dashboard-section">
      <BirthdayStatisticsV3 ref="birthdayComp" :auto-load="false" />
    </section>

    <!-- Footer Note -->
    <footer class="dashboard-footer">
      <p>Hệ Thống Báo Cáo & Quản Trị Toàn Diện OneKids • Phiên bản DashboardPlus V3.0</p>
    </footer>
  </div>
</template>

<script>
import moment from "moment";
import AttendanceStatisticsV3 from "./component/v3/AttendanceStatisticsV3.vue";
import EmployeeAttendanceStatisticsV3 from "./component/v3/EmployeeAttendanceStatisticsV3.vue";
import EvaluationStatisticsV3 from "./component/v3/EvaluationStatisticsV3.vue";
import NewsStatisticsV3 from "./component/v3/NewsStatisticsV3.vue";
import ScheduleStatisticsV3 from "./component/v3/ScheduleStatisticsV3.vue";
import MenuStatisticsV3 from "./component/v3/MenuStatisticsV3.vue";
import AlbumStatisticsV3 from "./component/v3/AlbumStatisticsV3.vue";
import TuitionStatisticsV3 from "./component/v3/TuitionStatisticsV3.vue";
import PersonnelKpiV3 from "./component/v3/PersonnelKpiV3.vue";
import BirthdayStatisticsV3 from "./component/v3/BirthdayStatisticsV3.vue";

export default {
  name: "DashboardPlusV3",
  components: {
    AttendanceStatisticsV3,
    EmployeeAttendanceStatisticsV3,
    EvaluationStatisticsV3,
    NewsStatisticsV3,
    ScheduleStatisticsV3,
    MenuStatisticsV3,
    AlbumStatisticsV3,
    TuitionStatisticsV3,
    PersonnelKpiV3,
    BirthdayStatisticsV3
  },
  data() {
    return {
      activeNav: "section-attendance",

      // Thẻ điều hướng danh mục phân hệ
      navSections: [
        {
          id: "section-attendance",
          name: "Điểm Danh",
          subtitle: "Học sinh",
          icon: "el-icon-user",
          color: "#2563eb",
          bgColor: "#eff6ff"
        },
        {
          id: "section-emp-attendance",
          name: "Chấm Công",
          subtitle: "Nhân sự",
          icon: "el-icon-s-cooperation",
          color: "#059669",
          bgColor: "#ecfdf5"
        },
        {
          id: "section-news",
          name: "Tin Tức",
          subtitle: "Bản tin",
          icon: "el-icon-reading",
          color: "#d97706",
          bgColor: "#fffbeb"
        },
        {
          id: "section-evaluation",
          name: "Nhận Xét",
          subtitle: "Đánh giá",
          icon: "el-icon-chat-line-round",
          color: "#7c3aed",
          bgColor: "#f5f3ff"
        },
        {
          id: "section-schedule",
          name: "Thời Khóa Biểu",
          subtitle: "Lịch học",
          icon: "el-icon-time",
          color: "#0284c7",
          bgColor: "#f0f9ff"
        },
        {
          id: "section-menu",
          name: "Thực Đơn",
          subtitle: "4 Bữa ăn",
          icon: "el-icon-dish",
          color: "#ea580c",
          bgColor: "#fff7ed"
        },
        {
          id: "section-album",
          name: "Album Ảnh",
          subtitle: "Hoạt động",
          icon: "el-icon-picture-outline",
          color: "#db2777",
          bgColor: "#fdf2f8"
        },
        {
          id: "section-tuition",
          name: "Học Phí",
          subtitle: "Khoản thu",
          icon: "el-icon-wallet",
          color: "#4f46e5",
          bgColor: "#eef2ff"
        },
        {
          id: "section-personnel-kpi",
          name: "KPI Nhân Sự",
          subtitle: "Hiệu quả",
          icon: "el-icon-data-analysis",
          color: "#0f766e",
          bgColor: "#ccfbf1"
        },
        {
          id: "section-birthday",
          name: "Sinh Nhật",
          subtitle: "Chúc mừng",
          icon: "el-icon-present",
          color: "#f43f5e",
          bgColor: "#fff1f2"
        }
      ],
      isDestroyed: false
    };
  },

  computed: {
    formattedCurrentDate() {
      const weekdays = ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"];
      const now = new Date();
      return `${weekdays[now.getDay()]}, ngày ${moment().format("DD/MM/YYYY")}`;
    },
    currentSchoolName() {
      const user = this.$store?.state?.auth?.user;
      if (user?.schoolInfor?.schoolName) {
        return user.schoolInfor.schoolName;
      }
      try {
        const stored = JSON.parse(localStorage.getItem("user"));
        if (stored?.schoolInfor?.schoolName) {
          return stored.schoolInfor.schoolName;
        }
      } catch (e) {
        // ignore parse error
      }
      const schoolData = this.$store?.state?.schoolStore?.schoolData;
      if (schoolData?.schoolName) {
        return schoolData.schoolName;
      }
      return "Hệ thống Quản lý Giáo dục Mầm non OneKids";
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$el) {
        this.$el.addEventListener("scroll", this.handleContainerScroll, { passive: true });
      }
      if (this.$store?.dispatch) {
        this.$store.dispatch("schoolStore/fetchDataSchoolData").catch(() => {});
      }
      this.loadComponentsSequentially();
    });
  },

  beforeDestroy() {
    this.isDestroyed = true;
    if (this.$el) {
      this.$el.removeEventListener("scroll", this.handleContainerScroll);
    }
  },

  methods: {
    async loadComponentsSequentially() {
      const componentsOrder = [
        "attendanceComp",
        "empAttendanceComp",
        "newsComp",
        "evaluationComp",
        "scheduleComp",
        "menuComp",
        "albumComp",
        "tuitionComp",
        "personnelKpiComp",
        "birthdayComp"
      ];

      for (const compRefName of componentsOrder) {
        if (this.isDestroyed) return;
        const comp = this.$refs[compRefName];
        if (comp && typeof comp.loadData === "function") {
          try {
            await comp.loadData();
          } catch (err) {
            console.error(`Lỗi khi tải dữ liệu cho ${compRefName}:`, err);
          }
          if (this.isDestroyed) return;
          // Khoảng đệm an toàn giữa các component (100ms) để hệ thống BE và rate-limit không bị quá tải
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
      }
    },

    triggerComponentLoad(sectionId) {
      const sectionRefMap = {
        "section-attendance": "attendanceComp",
        "section-emp-attendance": "empAttendanceComp",
        "section-news": "newsComp",
        "section-evaluation": "evaluationComp",
        "section-schedule": "scheduleComp",
        "section-menu": "menuComp",
        "section-album": "albumComp",
        "section-tuition": "tuitionComp",
        "section-personnel-kpi": "personnelKpiComp",
        "section-birthday": "birthdayComp"
      };
      const compRefName = sectionRefMap[sectionId];
      if (compRefName && this.$refs[compRefName]) {
        const comp = this.$refs[compRefName];
        if (comp && typeof comp.loadData === "function") {
          comp.loadData().catch(() => {});
        }
      }
    },

    scrollToSection(id) {
      this.activeNav = id;
      this.triggerComponentLoad(id);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    handleContainerScroll() {
      const container = this.$el;
      if (!container) return;
      const scrollY = container.scrollTop;
      const sectionIds = this.navSections.map((n) => n.id);

      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const id = sectionIds[i];
        const el = document.getElementById(id);
        if (el) {
          if (el.offsetTop <= scrollY + 140) {
            this.activeNav = id;
            this.triggerComponentLoad(id);
            break;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
/* Equal Height Charts Rows & Aligned Card Bottoms */
::v-deep .charts-row,
::v-deep .news-content-row {
  display: flex !important;
  flex-wrap: wrap !important;
}

::v-deep .charts-row::before,
::v-deep .charts-row::after,
::v-deep .news-content-row::before,
::v-deep .news-content-row::after {
  display: none !important;
}

::v-deep .charts-row > .el-col,
::v-deep .news-content-row > .el-col {
  display: flex !important;
  flex-direction: column !important;
}

::v-deep .charts-row > .el-col > .chart-card,
::v-deep .charts-row > .el-col > .upcoming-card,
::v-deep .news-content-row > .el-col > .card-box {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  box-sizing: border-box !important;
}

/* Main Container & Base Reset */
.dashboard-v3-container {
  height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 20px 24px 60px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #1e293b;
  -webkit-overflow-scrolling: touch;
}

/* Custom modern scrollbar */
.dashboard-v3-container::-webkit-scrollbar {
  width: 8px;
}
.dashboard-v3-container::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.dashboard-v3-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.dashboard-v3-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Header Banner */
.header-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8faff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.04);
  margin-bottom: 20px;
}

.greeting-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #4f46e5;
  background: #eef2ff;
  padding: 4px 12px;
  border-radius: 999px;
  margin-bottom: 8px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4f46e5;
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.2);
  animation: pulseAnim 2s infinite;
}

@keyframes pulseAnim {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.6); }
  70% { transform: scale(1); box-shadow: 0 0 0 8px rgba(79, 70, 229, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(79, 70, 229, 0); }
}

.header-title {
  margin: 0 0 4px;
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.header-subtitle {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

/* Sticky Navigation Card Bar */
.sticky-nav-wrapper {
  position: sticky;
  top: -20px;
  z-index: 999;
  background: rgba(248, 250, 252, 0.95);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  margin-left: -24px;
  margin-right: -24px;
  padding: 10px 24px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.85);
  box-shadow: 0 4px 18px -4px rgba(0, 0, 0, 0.05);
  margin-bottom: 22px;
}

.nav-cards-grid {
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.nav-card-tab {
  --accent-color: #4f46e5;
  --accent-bg: #f1f5f9;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  position: relative;
  overflow: hidden;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  min-width: 0;
}

.nav-card-tab:hover {
  transform: translateY(-2px);
  border-color: var(--accent-color, #4f46e5);
  box-shadow: 0 6px 14px -2px rgba(0, 0, 0, 0.07);
}

.nav-card-tab.active {
  background: #ffffff;
  border-color: var(--accent-color, #4f46e5);
  box-shadow: 0 4px 14px -2px rgba(79, 70, 229, 0.15);
}

.nav-card-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--accent-bg, #f1f5f9);
  color: var(--accent-color, #4f46e5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.nav-card-tab:hover .nav-card-icon,
.nav-card-tab.active .nav-card-icon {
  transform: scale(1.08);
}

.nav-card-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.nav-card-title {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.nav-card-tab.active .nav-card-title {
  color: var(--accent-color, #4f46e5);
  font-weight: 800;
}

.nav-card-sub {
  font-size: 10.5px;
  font-weight: 500;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.nav-card-glow-bar {
  position: absolute;
  bottom: 0;
  left: 8px;
  right: 8px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--accent-color, #4f46e5);
  opacity: 0;
  transform: scaleX(0.3);
  transition: all 0.22s ease;
}

.nav-card-tab.active .nav-card-glow-bar {
  opacity: 1;
  transform: scaleX(1);
}

.dashboard-section {
  margin-bottom: 32px;
  scroll-margin-top: 85px;
}

/* Dashboard Footer */
.dashboard-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
}

/* Responsive adjustments - Luôn duy trì 1 hàng duy nhất */
@media (max-width: 1360px) {
  .nav-cards-grid {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 6px;
    scrollbar-width: thin;
    gap: 8px;
  }
  .nav-card-tab {
    flex: 0 0 auto;
    min-width: 120px;
  }
}

@media (max-width: 991px) {
  .header-banner {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
